import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";









const SubCategoriesProduct = (props) => {
  const [CategoriesUrl, setCategoriesUrl] = useState("")
  const [Product, setProduct] = useState([])
  const [Product1, setProduct1] = useState([])
  const [Product2, setProduct2] = useState([])
  const [Categories, setCategories] = useState([])
  const [fal, setFal] = useState(false)
  const [fal1, setFal1] = useState(false)
  const [CategoriesName, setCategoriesname] = useState({})
  const [SubCategories, setSubCategories] = useState([])
  const [SubClassCategories, setSubClassCategories] = useState([])
  const [subCate, setsubCate] = useState([])
  const [allproduct, setallproduct] = useState([])
  const [Subproduct, setSubproduct] = useState([])
  const [Subproduct1, setSubproduct1] = useState([])
  const [SortedData, setSortedData] = useState([])
  const [SortedName, setSortedName] = useState([])
  const [SliderPhoto, setSliderPhoto] = useState([])
  const [DataPart2, setDataPart2] = useState([])
  const [MainCatogories, setMainCatogories] = useState([])
  const [dispaluy53, setdispaluy53] = useState(true)
  const [Cate1, setCate1] = useState([])
  const [Cate2, setCate2] = useState([])
  // categoriesName subcategories

  useEffect(() => {

    window.scrollTo(0, 0)
    // console.log( props.match.params);

    // const Inter = setInterval(()=>{
    //  if (!JSON.parse(localStorage.getItem("CateProduct")) ){
    //  var data1 = JSON.parse(localStorage.getItem("Cate")) 

    // var Category =  props.match.url.split("/")
    // setCategoriesUrl(data1)
    // var Category1 =  CategoriesUrl.split("-").join(" ")
    fetch("https://yasir-rentacar-main-back.vercel.app/AllProduct", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(res7 => res7.json())
      .then(res8 => {
        setallproduct(res8)
        const NonActive = res8.filter((res9, i) => {
          // console.log(res9.status , res9.Product_Catagories , "Cars"  , res9.Product_Sub_Catagories , Categoriesname.subCate );
          if (res9.status && res9.Product_Catagories === "Cars") {
            return res9
          }
        })

        setSubproduct(NonActive)
        console.log(NonActive)
      })





  }, [])


  const setSortPrice1 = (e) => {
    setdispaluy53(!dispaluy53)
    if (Subproduct.length !== 0) {

      SortedName.push(e)
      console.log(e, Subproduct);
      if (e === "Low") {
        const Pro6 = Subproduct.sort(function (a, b) {
          return parseFloat(a.Product_Price) - parseFloat(b.Product_Price)
        });
        console.log(Pro6);
        let reversed_array = [];
        Pro6.forEach((element) => {
          reversed_array.unshift(element);
        });
        console.log(Pro6, reversed_array)
        setSubproduct(reversed_array)
        setSubproduct(Pro6)
        setdispaluy53(!dispaluy53)
        setdispaluy53(!dispaluy53)

      }
      if (e === "High") {
        const Pro6 = Subproduct.sort((a, b) => {
          return parseFloat(b.Product_Price) - parseFloat(a.Product_Price)

        });
        //   let reversed_array = [];
        //   Pro6.forEach((element) => {
        //     reversed_array.unshift(element);
        // });
        //   console.log(Pro6,reversed_array)
        setSubproduct(Pro6)
        setdispaluy53(!dispaluy53)
        setdispaluy53(!dispaluy53)

      }
      if (e === "A") {
        const Pro6 = Subproduct.sort((a, b) => {
          var nameA = a.Product_Name.toUpperCase();
          var nameB = b.Product_Name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0;
        });
        console.log(Pro6);
        setSubproduct(Pro6)

      }

      setSubproduct1([])
      setdispaluy53(!dispaluy53)

    }
    else {

      SortedName.push(e)
      console.log(e);
      if (e === "Low") {
        const Pro6 = Subproduct.sort((a, b) => {
          return parseFloat(b.Product_Price) - parseFloat(a.Product_Price)

        });
        setSubproduct1(Pro6)

      }
      if (e === "High") {
        const Pro6 = Subproduct.sort((a, b) => {
          return parseFloat(b.Product_Price) - parseFloat(a.Product_Price)

        });
        setSubproduct1(Pro6.reverse())

      }
      if (e === "A") {
        const Pro6 = Subproduct.sort((a, b) => {
          var nameA = a.Product_Name.toUpperCase();
          var nameB = b.Product_Name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0;
        });
        console.log(Pro6);
        setSubproduct1(Pro6)

      }


      setSubproduct([])
    }
    setdispaluy53(!dispaluy53)

  }



  return (





    <>
      <main className="main">
        <div className="text-center">
          <div className="container">
            <h1 className="page-title" style={{ fontSize: "27px", fontWeight: "bold", margin: "0px 10px", padding: 0, textTransform: "uppercase" }}>Corporate Fleet Rental Services in Islamabad<span></span></h1>
          </div>{/* End .container */}
        </div>{/* End .page-header */}
        <hr style={{ margin: "0px" }} />
        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="toolbox">
                  <div className="toolbox-left" style={{ width: "100%" }}>
                    <div className="toolbox-info" style={{ width: "100%" }}>
                      <div className='dskjffkj' style={{ width: "100%", display: "flex", color: "black" }}>

                        <div>
                          <span style={{ color: "black", fontSize: "18px" }}>{Subproduct.length} <b>Cars</b>  founds</span>
                        </div>
                      </div>

                    </div>{/* End .toolbox-info */}
                  </div>{/* End .toolbox-left */}

                </div>{/* End .toolbox */}
                <div className="container products mb-3">
                  <div className="row justify-content-center">
                    {Subproduct.map((res, i) => {
                      return (
                        <div className="col-12 col-md-4 col-lg-4 col-xl-3">
                          <div className="product product-7 text-center" style={{ height: "auto" }}>
                            <figure className="product-media">
                              <Link>
                                <img src={res.Product_Image_Upload} alt="Product image" className="w-100" style={{ height: "250px" }} />
                              </Link>

                            </figure>{/* End .product-media */}
                            <div className="product-body">
                              <div className="product-cat">
                              </div>{/* End .product-cat */}
                              <h3 className="product-title" style={{ maxWidth: "100%", maxHeight: "59px", overflow: "hidden", textAlign: "left" }}><Link style={{ color: "black", fontSize: "20px" }}>{res.Product_Name}</Link></h3>{/* End .product-title */}
                              <hr style={{ margin: "0px" }} />


                              <div className="product-action position-relative visible" style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
                                {res.Product_Price_Discounted ?
                                  <><span className="product-price" style={{ fontSize: "14px", fontWeight: "bold", color: "black" }}>Rs {res.Product_Price_Discounted} <br /> / Day</span></>
                                  :
                                  <span style={{ fontSize: "14px", fontWeight: "bold", color: "black" }}>
                                    Rs {(res.Product_Price)} <br />
                                    / Day
                                  </span>
                                }
                                <span className="shadow-none" style={{ borderRadius: "15px", maxWidth: "150px", color: "white", background: "#0d6efd", padding: "10px 15px", color: "white", fontSize: "12px", fontWeight: "bold" }} ><a href="tel:+923191793992" style={{ color: "white" }}>Call Now</a> </span>
                                <span className="shadow-none" style={{ borderRadius: "15px", maxWidth: "150px", color: "white", background: "#0d6efd", padding: "10px 15px", color: "white", fontSize: "12px", fontWeight: "bold" }} ><a href="https://wa.me/923191793992?text=Hi *Rent a Car*! I need more info about" style={{ color: "white" }}>Book Now </a></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })
                    }
                    <div className='container' style={{ margin: "30px 10px" }}>
                      <div className='row'  >
                        <div className="col-10 col-lg-10  col-sm-12" style={{ margin: "auto" }}>

                          <section>
                            <h2>Corporate Fleet Rental Services in Islamabad</h2>

                            <p style="color:black; font-weight:400;">
                              Enhance your business operations with our <b>Corporate Fleet Rental Services in Islamabad</b>. Designed for companies, organizations, and corporate clients, our fleet rental solutions provide a reliable, professional, and cost-effective transportation option for employees, executives, and clients.
                            </p>

                            <p style="color:black; font-weight:400;">
                              Our service combines <b>efficiency, flexibility, and professionalism</b>, offering well-maintained vehicles and experienced drivers for corporate travel needs. From daily commutes to business trips, airport transfers, and event transportation, we ensure timely and comfortable travel across Islamabad and nearby areas.
                            </p>

                            <ul style="color:black; font-weight:400;">
                              <li><b>Wide fleet options:</b> Sedans, SUVs, and luxury cars to suit corporate requirements and group sizes.</li>
                              <li><b>Professional drivers:</b> Courteous, punctual, and experienced chauffeurs who understand corporate travel needs.</li>
                              <li><b>Flexible rental plans:</b> Hourly, daily, weekly, or monthly packages tailored for corporate operations.</li>
                              <li><b>Cost-effective solutions:</b> Competitive pricing and fleet management options for businesses of all sizes.</li>
                              <li><b>Reliable and safe service:</b> Vehicles are regularly maintained and equipped with modern safety features.</li>
                            </ul>

                            <p style="color:black; font-weight:400;">
                              Book your <b>corporate fleet rental in Islamabad</b> today and streamline your business transportation with professionalism, comfort, and reliability. Ideal for corporate offices, event management, and executive travel, our service guarantees seamless operations and satisfied clients.
                            </p>
                          </section>





                        </div>
                      </div>
                    </div>



                  </div>{/* End .row */}
                </div>{/* End .products */}
                <nav aria-label="Page navigation">
                  <ul className="pagination justify-content-center">
                    <li className="page-item disabled">
                      <a className="page-link page-link-prev" href="#" aria-label="Previous" tabIndex={-1} aria-disabled="true">
                        <span aria-hidden="true"><i className="icon-long-arrow-left" /></span>Prev
                      </a>
                    </li>
                    <li className="page-item active" aria-current="page"><a className="page-link" href="#">1</a></li>
                    {/* <li className="page-item"><a className="page-link" href="#">2</a></li>
                      <li className="page-item"><a className="page-link" href="#">3</a></li>
                      <li className="page-item-total">of 6</li> */}
                    <li className="page-item">
                      <a className="page-link page-link-next" href="#" aria-label="Next">
                        Next <span aria-hidden="true"><i className="icon-long-arrow-right" /></span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>{/* End .col-lg-9 */}

            </div>{/* End .row */}
          </div>{/* End .container */}
        </div>{/* End .page-content */}
      </main>{/* End .main */}




    </>
  )
}



export default SubCategoriesProduct;